export default function SearchInputIcon() {
  return (
    <svg
      className="searchIcon"
      width="28"
      height="28"
      viewBox="0 0 35 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <circle cx="14.5249" cy="14.2803" r="11.6836" strokeWidth="3.86817" />
      <line
        x1="26.1196"
        y1="23.2303"
        x2="31.2641"
        y2="27.7037"
        strokeWidth="4.08521"
        strokeLinecap="round"
      />
    </svg>
  )
}
